<template>
  <TextUpload
    :titleUpload="titleUpload"
    :subtitletUpload="subtitleUpload"
  />
  <CardUploadStatus
    v-for="(file, i) in documentationFileDetails" :key="i"
    :isVisibleTitleCard="file.statusUpload != 'Success'"
    :titleCard="file.cardName"
    :isVisibleTitle="file.statusUpload == 'Success'"
    :titleFile="file.cardName"
    :subtitleFile="file.fileName"
    :isError="file.statusUpload == 'Error'"
    :isVisibleStatus="file.statusUpload != 'Success'"
    :status="'0'"
    :isVisibleIconFile="file.statusUpload != 'Success'"
    :isVisibleIconCheck="file.statusUpload == 'Success'"
    :isVisibleIconArrow="file.statusUpload == 'Error'"
    :isVisibleIconTrash="file.statusUpload != 'Error'"
    @try-again-click="handleTryAgainClick(file.routeNameComponent)"
  />
  <FooterButton :confirmData="confirmData" :isDisabled="isAnyUploadInProgress"/>
</template>

<script>
  import CardUploadStatus from '@/cadastro/components/CardUploadStatus.vue';
  import FooterButton from '../../components/FooterButton.vue';
  import TextUpload from '@/cadastro/components/TextUpload.vue';
  import { useStore } from '@/stores/cadastro';
  import { useRouter } from 'vue-router';
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import { computed } from 'vue';

  export default {
    components: {
      CardUploadStatus,
      FooterButton,
      TextUpload
    },
    setup() {
      const store = useStore();
      const router = useRouter();

      const confirmData = async () => {
      const data = store.getDocumentationsData;
      data.registration_steps = {documents: true}
      const driverId = store.getDriverId

      try {
        const response = await axios.post(`/cadastro-motorista/update/${driverId}`, {
          data: data
        });
        if (response.data && response.data.id) {
          store.setDriverId(response.data.id);
        }
        Swal.fire({
          title: 'Dados enviados com sucesso!',
          text: 'Suas documentações foram salvas, por favor informe o restante dos dados nos passos seguintes.',
          icon: 'success',
          allowOutsideClick: false,
          timer: 10000,
          timerProgressBar: true,
          showConfirmButton: true,
          confirmButtonText: 'Ok'
        }).then(() => {
          if (response.status == 200) {
            router.push({ name: 'StatusRegistration' });
          }
        });
      } catch (error) {
          console.error('Erro inesperado:', error);
          Swal.fire({
          title: 'Ops...',
          text: 'Erro inesperado, por favor tente novamente mais tarde.',
          icon: 'error',
          confirmButtonText: 'Ok'
          });
      }
    };

      const documentationFiles = computed(() => store.getDocumentationFile);
      const documentationFileDetails = computed(() =>
        Object.values(documentationFiles.value).map(file => ({
          cardName: file.cardName,
          fileName: file.fileName,
          routeNameComponent: file.routeNameComponent,
          statusUpload: file.statusUpload
        }))
      );

      const isAnyUploadInProgress = computed(() => 
          documentationFileDetails.value.some(file => file.statusUpload !== 'Success')
        );

      const titleUpload = computed(() => {
        if (documentationFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'Upload com falha!';
        } else if (documentationFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Temos suas fotos!';
        } else {
          return 'Upload em andamento!';
        }
      });

      const subtitleUpload = computed(() => {
        if (documentationFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'Um ou mais uploads falharam. Por favor, tente novamente.';
        } else if (documentationFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Suas informações foram salvas com sucesso.';
        } else {
          return 'Há uploads em andamento. Por favor, aguarde.';
        }
      });

      return {
        confirmData,
        documentationFileDetails,
        isAnyUploadInProgress,
        titleUpload,
        subtitleUpload,
        store
      };
    },
    methods: {
      handleTryAgainClick(routeNameComponent) {
        const correspondingRoute = this.getCorrespondingRoute(routeNameComponent);
        this.store.updateDocumentationFile(routeNameComponent, false)
        this.$router.push({ name: correspondingRoute });
      },
      getCorrespondingRoute(routeNameComponent) {
        const routeMap = {
          'cnh': 'UploadCnh',
          'selfie_cnh': 'UploadSelfieCnh',
          'renavam': 'UploadRenavam',
          'crlv': 'UploadCrlv',
        };
        return routeMap[routeNameComponent];
      }
    }
  }
</script>
